import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'

const role = {
  addRole(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Role/edit`,
      data
    })
  },
  deleteRole(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Role/del?rid=${id}`
    })
  },
  getRoles() {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Role/Items`
    })
  },
  getAuthMenu() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v3/User/Menu/Items?flag=woyou`
    })
  },
  getAuthByRole(id) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v3/User/Role/GetJurisdiction_v3?id=${id}`
    })
  },
  setRoleAuth(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v3/User/Role/RoleJurisdictionEdit`,
      data
    })
  }
}

export default role
